<template>
	<AppModal ref="modal" id="editProductTitle" title="Edit title" @close="closeModalResetData" @open="createDataBackup">
		<div class="form-group mb-4">
			<div class="position-relative">
				<AppInput v-model="newTitleValue" :placeholder="''" id="title" maxlength="50" :class="{ 'form-error': $v.newTitleValue.$invalid }" />
			</div>
		</div>

		<AppButton name="update-title-button" class="update-button w-100" @click="updateTitleAndCloseModal" :disabled="$v.newTitleValue.$invalid">
			Confirm
		</AppButton>
	</AppModal>
</template>

<script>
	// eslint-disable-next-line import/extensions
	import { required } from 'vuelidate/lib/validators'

	export default {
		props: {
			value: {
				type: String,
				default: '',
			},
		},
		data() {
			return {
				newTitleValue: '',
			}
		},
		validations: {
			newTitleValue: { required },
		},
		methods: {
			show() {
				$(this.$refs.modal.$el).modal('show')
			},
			closeModal() {
				$(this.$refs.modal.$el).modal('hide')
				this.$emit('close-modal')
			},
			createDataBackup() {
				// Use the value directly to avoid showing placeholder
				this.newTitleValue = this.value || ''
			},
			closeModalResetData() {
				this.closeModal()
			},
			updateTitleAndCloseModal() {
				this.$v.$touch()
				if (this.$v.$invalid) return

				this.$emit('input', this.newTitleValue)
				this.closeModal()
			},
		},
		watch: {
			value: {
				immediate: true,
				handler(newVal) {
					// Set initial value immediately to prevent placeholder from showing
					this.newTitleValue = newVal || ''
				},
			},
		},
		mounted() {
			this.createDataBackup()
		},
	}
</script>
